export const sizes = {
  xlarge: "24px",
  large: "18px",
  medium_large: "16px",
  medium: "14px",
  small: "12px",
  xsmall: "10px"
};

export const fontWeights = {
  bold: 700,
  semibold: 600,
  regular: 400
};
